import React, { useState, useContext, useEffect, useMemo } from "react"
import styled from "styled-components"
import { ContextStore } from "Reducer"
import { List, Map } from "immutable"
import { useTranslation } from "react-i18next"
import media from "cssMix"
import get from "lodash/get"
import useMediaQuery from "useHooks/useMediaQuery"

import ModalBox from "Components/common/Modalbox"

// carousel
import Slider from "react-slick"

// icon
import { BsChevronLeft, BsChevronRight } from "react-icons/bs"

function NextArrow(props) {
  const { className, style, onClick } = props
  return (
    <IconContianer
      className={className}
      style={{ ...style }}
      onClick={onClick}
      position={{ right: "-65px" }}
      mobilePosition={{ right: "-45px" }}
    >
      <BsChevronRight />
    </IconContianer>
  )
}
function PreArrow(props) {
  const { className, style, onClick } = props
  return (
    <IconContianer
      className={className}
      style={{ ...style }}
      onClick={onClick}
      position={{ left: "-65px" }}
      mobilePosition={{ left: "-45px" }}
    >
      <BsChevronLeft />
    </IconContianer>
  )
}
const sliderSettings = {
  dots: true,
  lazyLoad: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  nextArrow: <NextArrow />,
  prevArrow: <PreArrow />,
}

export default (props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [modalContent, setModalContent] = useState(false)
  const [modalSeq, setModalSeq] = useState(0)
  const {
    state: { stateReducer },
  } = useContext(ContextStore)
  const lang = stateReducer.get("lang")
  const advertise = stateReducer.get("advertise", Map())
  const advertiseIsLoading = advertise.get("isLoading")
  const advertiseListData = advertise.get("data", List())
  const announcement = stateReducer.get("announcement", Map())
  const announcementIsLoading = announcement.get("isLoading")
  const announcementData = announcement.get("data", List())
  const modalList = useMemo(() => {
    if (!advertiseIsLoading && !announcementIsLoading) {
      setModalOpen(true)
      const announcementConfig = Map()
        .set("containerSize", {
          pc: {
            width: "600px",
            height: "350px",
          },
          mobile: {
            width: "300px",
            height: "280px",
          },
        })
        .set("styledComp", {
          background: "#31302c",
          padding: "10px",
        })
        .set("data", announcementData)

      const advertiseListConfig = Map()
        .set("containerSize", {
          pc: {
            width: "450px",
            height: "630px",
          },
          mobile: {
            width: "280px",
            height: "392px",
          },
        })
        .set("styledComp", {})
        .set("data", advertiseListData)

      return mapList([announcementConfig, advertiseListConfig], List())
    }
    return List()
  }, [
    advertiseIsLoading,
    advertiseListData,
    announcementData,
    announcementIsLoading,
  ])

  const { t } = useTranslation()

  function mapList(array, pre, lang) {
    return array.reduce((acc, cur, index) => acc.set(index, cur), pre)
  }

  function countModalClose() {
    setModalContent(false)
    setModalSeq((pre) => ++pre)
  }

  useEffect(() => {
    if (
      modalList.getIn([modalSeq, "data"], List()).size === 0 &&
      modalSeq <= modalList.size &&
      !advertiseIsLoading &&
      !announcementIsLoading
    )
      setModalSeq((pre) => ++pre)
  }, [advertiseIsLoading, announcementIsLoading, modalList, modalSeq])

  useEffect(() => {
    if (modalSeq <= modalList.size) {
      setTimeout(() => {
        setModalContent(true)
      }, 400)
    } else {
      setModalOpen(false)
    }
  }, [modalContent, modalList.size, modalSeq])

  return (
    <MapComponent
      modalArray={modalList}
      modalSeq={modalSeq}
      modalOpen={modalOpen}
      onModalClose={countModalClose}
      lang={lang}
      t={t}
      modalContent={modalContent}
      setModalSeq={setModalSeq}
    />
  )
}

const MapComponent = ({
  modalArray,
  modalSeq,
  modalOpen,
  onModalClose,
  lang,
  t,
  modalContent,
}) => {
  const containerSize = modalArray.getIn([modalSeq, "containerSize"])
  const styledComp = modalArray.getIn([modalSeq, "styledComp"])
  const { mediaType } = useMediaQuery()

  return (
    <>
      {modalArray.size !== 0 && (
        <ModalBox
          isOpen={modalOpen}
          onModalClose={onModalClose}
          modalContent={modalContent}
          containerSize={containerSize}
        >
          <StyledSlider {...sliderSettings}>
            {modalArray.getIn([modalSeq, "data"], List()).map((v, i) => {
              const title = v.getIn(["title", lang])
              const content = v.getIn(["content", lang])
              const imgSrc = v.getIn(["image", lang, mediaType])
              const link = v.get("link")
              const imgClickHandler = (link) => {
                if (link) {
                  window.open(link)
                }
              }
              return (
                <Container
                  key={i}
                  styledComp={styledComp}
                  containerSize={containerSize}
                  link={link}
                >
                  {title && (
                    <div className="annnouceWrap">
                      <div className="title">{title}</div>
                      <div className="content">{content}</div>
                    </div>
                  )}

                  {imgSrc && (
                    <img
                      alt=""
                      src={imgSrc}
                      onClick={() => {
                        imgClickHandler(link)
                      }}
                    />
                  )}
                </Container>
              )
            })}
          </StyledSlider>
        </ModalBox>
      )}
    </>
  )
}

const Container = styled.div`
  ${({ styledComp }) => styledComp}
  ${({ containerSize }) => get(containerSize, "pc")};
  overflow: visible;
  white-space: wrap;
  box-sizing: border-box;
  .annnouceWrap {
    color: #ffffff;
    width: 100%;
    height: 100%;
    border: 1px solid ${({ theme }) => theme.colors["12"]};
    padding: 0 65px;
    box-sizing: border-box;
    .title {
      text-align: center;
      font-size: 26px;
      word-wrap: break-word;
      height: 20%;
      overflow: auto;
      box-sizing: border-box;
      margin: 20px 0;
      padding: 10px 0;
      width: 100%;
    }
    .content {
      width: 100%;
      height: 65%;
      margin: 0 auto;
      border-top: 1px solid rgba(131, 127, 116, 0.3);
      font-size: 18px;
      word-wrap: break-word;
      overflow: auto;
      box-sizing: border-box;
      /* margin:20px 0; */
      padding: 30px 0;
    }
  }
  > img {
    height: 100%;
    width: 100%;
    cursor: ${(props) => (props.link ? "pointer" : "auto")};
  }
  ${media.mobile`
      ${({ containerSize }) => get(containerSize, "mobile")};
    .annnouceWrap{
        padding:0 25px;

        .title{
            font-size:24px;
            margin:27px auto 17px auto;
        }
        .content{
            width:230px;
            height:60%;
            padding:20px 0;
            font-size:16px;
        }
    }
  `}
`

const StyledSlider = styled(Slider)`
  .slick-dots {
    bottom: -65px;
  }
  .slick-dots li button:before {
    content: " ";
    width: 10px;
    height: 10px;
    border-radius: 50px;
    background: #ffffff;
  }
  .slick-dots li.slick-active button:before {
    background: ${({ theme }) => theme.colors["1"]};

    border: 1px solid ${({ theme }) => theme.colors["1"]};
  }
`

const IconContianer = styled.div`
  width: 40px;
  height: 40px;
  ::before {
    content: "";
  }
  ${({ position }) => position}
  >svg {
    width: 40px;
    height: 40px;
    color: #ffffff;
  }
  ${media.mobile`
${({ mobilePosition }) => mobilePosition}

`}
`
